module.exports = __webpack_public_path__ + "assets/img/icon04.8db01a3f.png";